import { enrich } from '@i18n/localizeHelper'
import { municipalityTabs, regionTabs } from './constants'
import type { MunicipalityFeatures, RegionFeatures } from '@schema/featureToggle'

type RegionPageTabTitles = Record<RegionFeatures, string>
type MunicipalityPageTabTitles = Record<MunicipalityFeatures, string>

export const getRegionPageTitle = (
  tab: RegionFeatures,
  entityName: string,
  pageTabTitles: RegionPageTabTitles,
): string => {
  if (tab === regionTabs.overview) {
    return entityName
  }
  const template = pageTabTitles[tab]
  if (!template.includes('{0}')) {
    return template
  }
  return enrich(template, entityName)
}

export const getMunicipalityPageTitle = (
  tab: MunicipalityFeatures,
  entityName: string,
  pageTabTitles: MunicipalityPageTabTitles,
): string => {
  if (tab === municipalityTabs.overview) {
    return entityName
  }
  const template = pageTabTitles[tab]
  if (!template.includes('{0}')) {
    return template
  }
  return enrich(template, entityName)
}
